module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/military-maneuvers-elite.afa8cc43.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/military-maneuvers-elite.png
// module id = 3744
// module chunks = 11